import { forwardRef, useCallback } from 'react'

import {
  IconButton,
  PanelLeftCloseIcon,
  PanelLeftOpenIcon,
  useSidebar,
} from '@buffer-mono/popcorn'
import type { IconButtonProps } from '@buffer-mono/popcorn'

import styles from './SidebarTrigger.module.css'

type SidebarTriggerProps = Omit<IconButtonProps, 'children' | 'label'>

export const SidebarTrigger = forwardRef<
  HTMLButtonElement,
  SidebarTriggerProps
>(function SidebarTrigger({ onClick, ...props }, ref) {
  const { state, toggleSidebar } = useSidebar()

  const label = state === 'expanded' ? 'Close' : 'Open'

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      toggleSidebar()
      void onClick?.(event)
    },
    [toggleSidebar, onClick],
  )

  return (
    <IconButton
      ref={ref}
      className={styles.sidebarTrigger}
      variant="tertiary"
      onClick={handleClick}
      aria-expanded={state === 'expanded'}
      label={`${label} sidebar`}
      {...props}
    >
      {state === 'expanded' ? <PanelLeftCloseIcon /> : <PanelLeftOpenIcon />}
    </IconButton>
  )
})
